import { render, staticRenderFns } from "./setNewCable.vue?vue&type=template&id=25ccef15&scoped=true"
import script from "./setNewCable.vue?vue&type=script&lang=js"
export * from "./setNewCable.vue?vue&type=script&lang=js"
import style0 from "./setNewCable.vue?vue&type=style&index=0&id=25ccef15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ccef15",
  null
  
)

export default component.exports